///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const RefreshIcon = ({
  fill = "#343434",
  title = messages.refresh.defaultMessage,
  ...rest
}) => (
  <svg
    aria-labelledby="refresh-icon"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <title data-testid="refresh-icon">{title}</title>
    <defs>
      <path
        d="M11.8 4.2A5.3 5.3 0 002.7 8a5.3 5.3 0 0010.5 1.3h-1.4a4 4 0 11-1-4.1L8.7 7.3h4.6V2.7l-1.5 1.5z"
        id="refresh-icon-path"
      />
    </defs>
    <g transform="translate(-2 -2)" fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <mask id="refresh-icon-mask" fill="#fff">
        <use xlinkHref="#refresh-icon-path" />
      </mask>
      <path fill={fill} mask="url(#refresh-icon-mask)" d="M0 0h16v16H0z" />
    </g>
  </svg>
);

export default RefreshIcon;
